<template>
  <div class="all">
    <div v-for="(item, index) in list" :key="index" class="link-item" @click="jump(item.link)">
      <div class="logo"></div>
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
const portalUrl = process.env.VUE_APP_PORTAL_URL

export default {
  data() {
    return {
      declareList: [{
        name: '主单元',
        link: '/venturecapital/declare/add?type=2'
      }, {
        name: '制作中项目单元',
        link: '/venturewip/declare/add?type=2'
      }],
      appointmentList: [{
        name: '创投一对一洽谈',
        link: '/1v1/appointment/capital'
      }, {
        name: 'WIP一对一洽谈',
        link: '/1v1/appointment/wip'
      }],
      list: []
    }
  },
  created() {
    this.list = [].concat(this[this.$route.query.nav + 'List'])
  },
  methods: {
    jump(link) {
      location.href = link
    }
  }
}
</script>

<style scoped>
.all {
  margin: 174px auto 0;
  width: 1200px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
}

.link-item {
  font-size: 30px;
  color: #C1A17B;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link-item::after {
  content: "";
  margin-top: 15px;
  width: 0;
  height: 4px;
  background-color: #003E79;
  border-radius: 2px;
  display: block;
  transition: width 0.3s ease-in-out;
}

.logo {
  margin-bottom: 10px;
  width: 87px;
  height: 109px;
  background-image: url(../static/img/jinji_logo_n.svg);
}

.link-item:hover {
  color: #003E79;
}

.link-item:hover::after {
  width: 33px;
}

.link-item:hover .logo {
  background-image: url(../static/img/jinji_logo_p.svg);
}
</style>